function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classPrivateFieldSet(receiver, privateMap, value) { var descriptor = privateMap.get(receiver); if (!descriptor) { throw new TypeError("attempted to set private field on non-instance"); } if (descriptor.set) { descriptor.set.call(receiver, value); } else { if (!descriptor.writable) { throw new TypeError("attempted to set read only private field"); } descriptor.value = value; } return value; }

function _classPrivateFieldGet(receiver, privateMap) { var descriptor = privateMap.get(receiver); if (!descriptor) { throw new TypeError("attempted to get private field on non-instance"); } if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }

var _colorCount = new WeakMap();

export class Histogram {
  get colorCount() {
    return _classPrivateFieldGet(this, _colorCount);
  }

  constructor(pixels, {
    sigBits
  }) {
    _defineProperty(this, "getColorIndex", void 0);

    _defineProperty(this, "hist", void 0);

    _defineProperty(this, "rmin", void 0);

    _defineProperty(this, "rmax", void 0);

    _defineProperty(this, "gmin", void 0);

    _defineProperty(this, "gmax", void 0);

    _defineProperty(this, "bmin", void 0);

    _defineProperty(this, "bmax", void 0);

    _colorCount.set(this, {
      writable: true,
      value: void 0
    });

    const getColorIndex = (r, g, b) => (r << 2 * sigBits) + (g << sigBits) + b;

    const rshift = 8 - sigBits;
    const hist = new Uint32Array(1 << 3 * sigBits);
    let [rmax, rmin, gmax, gmin, bmax, bmin] = [0, Number.MAX_VALUE, 0, Number.MAX_VALUE, 0, Number.MAX_VALUE];
    let [r, g, b, a, n, i] = [0, 0, 0, 0, pixels.length / 4, 0];

    while (i < n) {
      const offset = i * 4;
      i++;
      r = pixels[offset + 0];
      g = pixels[offset + 1];
      b = pixels[offset + 2];
      a = pixels[offset + 3]; // Ignored pixels' alpha is marked as 0 in filtering stage

      if (a === 0) continue; // eslint-disable-line

      r >>= rshift;
      g >>= rshift;
      b >>= rshift;
      hist[getColorIndex(r, g, b)] += 1;
      if (r > rmax) rmax = r;
      if (r < rmin) rmin = r;
      if (g > gmax) gmax = g;
      if (g < gmin) gmin = g;
      if (b > bmax) bmax = b;
      if (b < bmin) bmin = b;
    }

    Object.assign(this, {
      hist,
      rmax,
      rmin,
      gmax,
      gmin,
      bmax,
      bmin
    });
    this.getColorIndex = getColorIndex;

    _classPrivateFieldSet(this, _colorCount, hist.reduce((total, c) => c > 0 ? total + 1 : total, 0));
  }

}